import { z } from 'zod';
/** Démonstration média locale (Sprint 1) : désactivée hors développement. */
export const mediaDemoTokenRequestSchema = z.object({
    displayName: z.string().trim().min(1).max(60),
});
export const livekitConnectionSchema = z.object({
    serverUrl: z.string().min(1),
    token: z.string().min(1),
    expiresAt: z.iso.datetime(),
});
//# sourceMappingURL=media-demo.js.map